export default {
    /**
     * @type {typeof Popin}
     */
    Popin: null,
    successMessagePopin: null,

    /**
     *
     * @param utils
     * @param {typeof Popin} Popin
     */
    init: function (utils, Popin) {
        this.Popin = Popin;

        this.mobileMenuToggle();
        this.initSalonToggle();
        this.initToggleCheckboxes();
        this.initCardMemberDelete();
        this.initFormSubmit();
        this.initFormRequiredCheckboxes();
        this.initInputLanguageSwitcher();

        this.initSuccessMessagePopin();
    },

    mobileMenuToggle: function () {
        const menuButton = document.querySelector('.js-portalDashboard__menuToggle');
        if (!menuButton) return;
        const menu = document.querySelector('.js-portalNavigation');

        menuButton.addEventListener('click', () => {
            menuButton.classList.toggle('opened');
            menu.classList.toggle('opened');
        });
    },

    initSalonToggle: function () {
        const toggleButtons = document.querySelectorAll('.js-portalNavigation__salon__toggle');

        if (!toggleButtons.length) return;

        toggleButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();

                const salonContainer = button.closest('.js-portalNavigation__salon');

                // Fermer tous les autres salons
                const allSalons = document.querySelectorAll('.js-portalNavigation__salon');
                allSalons.forEach(salon => {
                    if (salon !== salonContainer) {
                        salon.classList.remove('opened');
                    }
                });

                // Toggle le salon courant
                salonContainer.classList.toggle('opened');
            });
        });
    },

    initToggleCheckboxes: function () {
        // Initialiser tous les toggles checkbox avec la nouvelle convention de nommage
        const toggleButtons = document.querySelectorAll('.js-inputGroup__toggle__switch');

        if (!toggleButtons.length) return;

        // Initialiser les textes des boutons depuis les éléments HTML
        this.initToggleTexts();

        // Ajouter les gestionnaires d'événements click
        toggleButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggleCheckbox(button);
            });

            // Support du clavier (Espace et Entrée)
            button.addEventListener('keydown', (e) => {
                if (e.key === ' ' || e.key === 'Enter') {
                    e.preventDefault();
                    this.toggleCheckbox(button);
                }
            });
        });

        // Mettre à jour l'état aria initial de tous les toggles
        this.updateAllToggleStates();
    },

    initToggleTexts: function () {
        // Initialiser le contenu des boutons toggle depuis les éléments HTML
        const toggleButtons = document.querySelectorAll('.js-inputGroup__toggle__switch');

        toggleButtons.forEach(button => {
            const toggle = button.closest('.inputGroup__toggle');
            if (toggle) {
                const statusOff = toggle.querySelector('.inputGroup__toggle__status--off');
                const statusOn = toggle.querySelector('.inputGroup__toggle__status--on');
                const checkbox = toggle.querySelector('.inputGroup__toggle__input');

                if (statusOff && statusOn && checkbox) {
                    // Mettre à jour le contenu selon l'état initial du checkbox
                    this.updateToggleText(button, checkbox, statusOff.textContent.trim(), statusOn.textContent.trim());
                }
            }
        });
    },

    updateToggleText: function (button, checkbox, textOff, textOn) {
        // Mettre à jour le contenu du bouton selon l'état du checkbox
        const currentText = checkbox.checked ? textOn : textOff;
        button.setAttribute('data-current-text', currentText);

        // Mettre à jour le CSS content via une propriété CSS custom
        button.style.setProperty('--toggle-text', `"${currentText}"`);

        // Alternative: utiliser directement textContent si on ne veut pas de pseudo-element
        // button.textContent = currentText;
    },

    toggleCheckbox: function (button) {
        // Trouver le checkbox associé (élément précédent)
        const checkbox = button.previousElementSibling;

        if (!checkbox || !checkbox.classList.contains('js-inputGroup__toggle__input')) {
            console.warn('Checkbox associé non trouvé pour le toggle');
            return;
        }

        // Basculer l'état du checkbox
        checkbox.checked = !checkbox.checked;

        // Mettre à jour le texte du bouton
        const toggle = button.closest('.inputGroup__toggle');
        if (toggle) {
            const statusOff = toggle.querySelector('.js-inputGroup__toggle__status--off');
            const statusOn = toggle.querySelector('.js-inputGroup__toggle__status--on');

            if (statusOff && statusOn) {
                this.updateToggleText(button, checkbox, statusOff.textContent.trim(), statusOn.textContent.trim());
            }
        }

        // Déclencher l'événement change pour les autres scripts qui pourraient écouter
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));

        // Mettre à jour l'attribut aria-checked du bouton
        this.updateToggleAriaState(button, checkbox);

        // Ajax request to update the user sheet visibility
        if (checkbox.dataset.userSheetId) {
            const notification = button.closest('.js-team-member-actions').querySelector('.notification');
            this.toggleVisibilityAjax(parseInt(checkbox.dataset.userSheetId), checkbox.checked, parseInt(checkbox.dataset.salonId), notification);
        }
    },

    /**
     * Ajax request to update the user sheet visibility
     * @param {number} userSheetId - The user sheet id
     * @param {boolean} visibility - The visibility
     * @param {number} salonId - The salon id
     */
    toggleVisibilityAjax: function (userSheetId, visibility, salonId, notification) {
        fetch(wordpress_vars.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: new URLSearchParams({
                action: 'update_user_sheet_visibility',
                post_id: userSheetId,
                value: visibility,
                salon_id: salonId
            })
        })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                notification.classList.remove('--hidden');
                setTimeout(() => {
                    notification.classList.add('--hidden');
                }, 3000);
            } else {
                console.error('Erreur lors de la mise à jour', data);
            }
        });
    },

    updateToggleAriaState: function (button, checkbox) {
        if (button && checkbox) {
            button.setAttribute('aria-checked', checkbox.checked ? 'true' : 'false');
        }
    },

    updateAllToggleStates: function () {
        // Mettre à jour l'état aria de tous les toggles au chargement
        const toggleButtons = document.querySelectorAll('.js-inputGroup__toggle__switch');
        toggleButtons.forEach(button => {
            const checkbox = button.previousElementSibling;
            if (checkbox && checkbox.classList.contains('js-inputGroup__toggle__input')) {
                this.updateToggleAriaState(button, checkbox);
            }
        });
    },

    initCardMemberDelete: function () {
        const cardMemberDelete = document.querySelectorAll('.js-card-member-delete');
        cardMemberDelete.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();

                const message = "Voulez-vous vraiment supprimer ce membre ?"

                if (!confirm(message)) {
                    return;
                }

                const salonId = button.dataset.salonId;
                const exhibitorId = button.dataset.exhibitorId;
                const userId = button.dataset.userId;
                const cardMember = button.closest('.jscardMember');

                this.deleteCardMemberAjax(salonId, exhibitorId, userId, cardMember);
            });
        });
    },

    deleteCardMemberAjax: function (salonId, exhibitorId, userId, cardMember) {
        fetch(wordpress_vars.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: new URLSearchParams({
                action: 'delete_member',
                salon_id: salonId,
                exhibitor_id: exhibitorId,
                user_id: userId,
            })
        })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                document.querySelector('.js-notification-delete-member').classList.remove('--hidden');
                cardMember.remove();
                setTimeout(() => {
                    document.querySelector('.js-notification-delete-member').classList.add('--hidden');
                }, 3000);
            } else {
                console.error('Erreur lors de la mise à jour', data);
            }
        });
    },

    /*
    * si checkbox requis, il faut gérer que si une seule est checkée, c'est ok (et pas TOUTES les checkboxes du groupe)
    */
    initFormRequiredCheckboxes: function() {
        const requiredCheckboxes = document.querySelectorAll('.js-required-checkboxes');
        requiredCheckboxes.forEach(checkboxGroup => {
            const checkboxes = checkboxGroup.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('change', () => {
                    let checked = checkboxGroup.querySelector('input[type="checkbox"]:checked')
                    if(!checked){
                        checkboxes.forEach(checkbox => {
                            checkbox.required = true;
                        });
                    } else {
                        checkboxes.forEach(checkbox => {
                            checkbox.required = false;
                        });
                    }
                });
                checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            });
        });
    },

    initSuccessMessagePopin: function(){
        const popinEl = document.querySelector('.js-successMessagePopin')
        if (popinEl) {
            this.successMessagePopin = new this.Popin(popinEl, {
                popinBackCSSSelector: '.js-successMessagePopin-back',
                popinContentCSSSelector: '.js-successMessagePopin-content'
            })
        }
    },

    triggerSuccessMessagePopin: function(){
        if (!this.successMessagePopin) return;

        this.successMessagePopin.open();

        const popinBody = document.querySelector('.js-successMessagePopin-body');
        if (popinBody) {
            setTimeout(() => {
                popinBody.textContent = "Cela prend plus de temps que prévu. Patientons encore un peu...";
            }, 5000);
            setTimeout(() => {
                popinBody.textContent = "Quelque chose semble s'être mal passé lors de l'envoi du formulaire. Rechargez la page et essayez à nouveau, ou contactez l'administrateur du site.";
            }, 10000);
        }
    },

    /**
     * Apply JS on form submissions
     */
    initFormSubmit: function() {
        const forms = document.querySelectorAll('.js-form-submit');
        forms.forEach(form => {
            form.addEventListener('submit', () => {
                // On submission, disable buttons and show loading indicator
                form.querySelectorAll('input[type="submit"]').forEach(button => {
                    button.disabled = true;
                    const originalValue = button.value;
                    button.value = 'En cours...';
                    // Restore buttons after several seconds (in case of something wrong happened)
                    setTimeout(() => {
                        button.disabled = false;
                        button.value = originalValue;
                    }, 8000);
                });
            });
        });

        if ( 'undefined' !== typeof acf ) {
            acf.add_filter( 'validation_complete', ( json, $form ) => {
                if ( !json.valid || json.errors ) {
                    if($form.closest('.js-drawer__wrapper')){
                        $form.closest('.js-drawer__wrapper').scrollTop(0);
                    }
                }
                return json;
            });
            // Display message before the page reload (this idea to fix the acf auto scroll on submit)
            acf.add_action('submit', () => {
                this.triggerSuccessMessagePopin();
            });
        }
    },

    /**
     * Allow switching between languages in input fields, by clicking on something like a flag.
     * Used for products, for example.
     */
    initInputLanguageSwitcher: function() {
        const containers = document.querySelectorAll('.input-with-languages');

        containers.forEach(container => {
            container.addEventListener('click', (event) => {
                // The switcher can be a flag (france, USA...) to click on, or anything else
                const switcher = event.target.closest('.js-input-language-switch');
                if (!switcher || !container.contains(switcher)) {
                    return;
                }

                const currentContainer = switcher.closest('.input-with-languages');
                const parent = currentContainer.parentElement;

                let next = currentContainer.nextElementSibling;

                // Loop on switchers/flags: if no next one, go to the first one
                if (!next || !next.classList.contains('input-with-languages')) {
                    next = parent.querySelector('.input-with-languages');
                }

                // Hide everything, but the next one
                parent.querySelectorAll('.input-with-languages').forEach(element => element.classList.add('hidden'));
                next.classList.remove('hidden');
            });
        });
    }
}
